import React from "react";

import {
  Box,
  Divider,
  Input,
  Kbd,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  Textarea,
} from "@chakra-ui/react";

// import { color } from "framer-motion";
import { useEffect, useState } from "react";


const Help = ({ isOpen, onClose, setChange, change }) => {
  const [shortcuts, setShortcuts] = useState(() => {
    const data = localStorage.getItem("shortcuts");
    return data
      ? JSON.parse(data)
      : {
        shortcut1: "\\looseness-1",
        shortcut2: "\\vfill\\eject",
        shortcut3: "\\unskip\\break",
        shortcut4: "",
        shortcut5: "",
        shortcut6: "",
      };
  });

  // console.log(Object.keys(shortcuts).map((key) => shortcuts[key]))

  const latexShortcuts = [
    { key: "Ctrl-Shift-Z", snippet: "\\emph{}", description: "Emphasis" },
    { key: "Ctrl-Shift-S", snippet: "\\textsl{}", description: "Slanted" },
    { key: "Ctrl-Shift-T", snippet: "\\texttt{}", description: "Typewriter" },
    { key: "Ctrl-Shift-C", snippet: "\\textsc{}", description: "Small caps" },
    { key: "Ctrl-Shift-A", snippet: "\\textsff{}", description: "Sans Serif" },
    { key: "Ctrl-Return", snippet: "\\\\", description: "New line" },
    { key: "Ctrl-Shift-M", snippet: "$…$", description: "Inline math mode" },
    { key: "Alt-Shift-M", snippet: "\\[…\\]", description: "Display math mode" },
    { key: "Ctrl-Shift-D", snippet: "_{}", description: "Subscript" },
    { key: "Ctrl-Shift-U", snippet: "^{}", description: "Superscript" },
    { key: "Ctrl-Shift-F", snippet: "\\frac{}{}", description: "Fraction" },
    { key: "Ctrl-Shift-Q", snippet: "\\dfrac{}{}", description: "Display fraction" },
    { key: "Ctrl-Shift-L", snippet: "\\sqrt{}", description: "Square root" },
    { key: "Ctrl-Shift-R", snippet: "\\left … \\right …", description: "Left-Right" },
    { key: "Ctrl-Shift-E", snippet: "\\begin{equation}\n\n\\end{equation}", description: "Equation environment" },
    { key: "Ctrl-Shift-B", snippet: "\\begin{figure}\n\\centering\n\\includegraphics{}\n\\caption{}\n\\end{figure}", description: "Equationenvironment" },
    { key: "Ctrl-Shift-G", snippet: "\\begin{table}\n\\caption{}\n\\begin{tabular}{lc}\n\\end{tabular}\n\\end{table}", description: "Add Table" },
  ];

  useEffect(() => {
    localStorage.setItem("shortcuts", JSON.stringify(shortcuts));
  }, [shortcuts]);

  const inputChange = (e, id) => {
    let updatedscut = { ...shortcuts };
    updatedscut[`shortcut${id}`] = e.target.value;
    setShortcuts(updatedscut);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size={"lg"}>
      <ModalOverlay />
      <ModalContent maxH="500px">
        <ModalHeader>Help</ModalHeader>
        <ModalCloseButton />
        <ModalBody overflow="auto">
          <Box display="flex" justifyContent="space-between" mb="3">
            <button paddingLeft="1px">
              <a
                href={
                  process.env.PUBLIC_URL +
                  "/manual/EditLaTeX Editor User Guide.pdf"
                }
                download={"EditLaTeX Editor User Guide.pdf"}
                style={{ color: "var(--error)" }}
              >
                Click to Download User Manual
              </a>
            </button>
          </Box>
          <Box className="shortcuts" display="flex" justifyContent="space-between" mb="3" color="var(--text-primary)">
            <Text paddingLeft="1px">LaTex Compile</Text>
            <span>
              <Kbd>Ctrl</Kbd> + <Kbd>F6</Kbd>
            </span>
          </Box>
          <Box display="flex" justifyContent="space-between" mb="3">
            <Text paddingLeft="1px">TrackLaTex Compile</Text>
            <span>
              <Kbd>Ctrl</Kbd> + <Kbd>F7</Kbd>
            </span>
          </Box>
          <Box display="flex" justifyContent="space-between" mb="3">
            <Text paddingLeft="1px">Search</Text>
            <span>
              <Kbd>Ctrl</Kbd> + <Kbd>F</Kbd>
            </span>
          </Box>
          <Box display="flex" justifyContent="space-between" mb="3">
            <Text paddingLeft="1px">Replace</Text>
            <span>
              <Kbd>Ctrl</Kbd> + <Kbd>R</Kbd>
            </span>
          </Box>
          <Box display="flex" justifyContent="space-between" mb="3">
            <Text paddingLeft="1px">Goto Line</Text>
            <span>
              <Kbd>Ctrl</Kbd> + <Kbd>L</Kbd>
            </span>
          </Box>
          <Box display="flex" justifyContent="space-between" mb="3">
            <Text paddingLeft="1px">Comment/Uncomment</Text>
            <span>
              <Kbd>Ctrl</Kbd> + <Kbd>/</Kbd>
            </span>
          </Box>
          <Box display="flex" justifyContent="space-between" mb="3">
            <Text paddingLeft="1px">Copy</Text>
            <span>
              <Kbd>Ctrl</Kbd> + <Kbd>C</Kbd>
            </span>
          </Box>
          <Box display="flex" justifyContent="space-between" mb="3">
            <Text paddingLeft="1px">Paste</Text>
            <span>
              <Kbd>Ctrl</Kbd> + <Kbd>V</Kbd>
            </span>
          </Box>
          <Box display="flex" justifyContent="space-between" mb="3">
            <Text paddingLeft="1px">Undo</Text>
            <span>
              <Kbd>Ctrl</Kbd> + <Kbd>Z</Kbd>
            </span>
          </Box>
          <Box display="flex" justifyContent="space-between" mb="3">
            <Text paddingLeft="1px">Redo</Text>
            <span>
              <Kbd>Ctrl</Kbd> + <Kbd>Shift</Kbd>+<Kbd>Z</Kbd> | <Kbd>Ctrl</Kbd> + <Kbd>Y</Kbd>
            </span>
          </Box>


          <Divider mb="3" />


          <Box display="flex" justifyContent="space-between" mb="3">
            <Text paddingLeft="1px">Bold</Text>
            <span>
              <Kbd>Ctrl</Kbd> + <Kbd>B</Kbd>
            </span>
          </Box>
          <Box display="flex" justifyContent="space-between" mb="3">
            <Text paddingLeft="1px">Italic</Text>
            <span>
              <Kbd>Ctrl</Kbd> + <Kbd>I</Kbd>
            </span>
          </Box>
          <Box display="flex" justifyContent="space-between" mb="3">
            <Text paddingLeft="1px">toUpperCase</Text>
            <span>
              <Kbd>Ctrl</Kbd> + <Kbd>U</Kbd>
            </span>
          </Box>
          <Box display="flex" justifyContent="space-between" mb="3">
            <Text paddingLeft="1px">toLowerCase</Text>
            <span>
              <Kbd>Alt</Kbd> + <Kbd>L</Kbd>
            </span>
          </Box>
          <Box display="flex" justifyContent="space-between" mb="3">
            <Text paddingLeft="1px">Insert Math</Text>
            <span>
              <Kbd>Ctrl</Kbd> + <Kbd>Q</Kbd>
            </span>
          </Box>

          <Box display="flex" justifyContent="space-between" mb="3">
            <Text paddingLeft="1px">Create Tex File</Text>
            <span>
              <Kbd>Ctrl</Kbd> + <Kbd>F2</Kbd>
            </span>
          </Box>

          <Divider mb="3" />

          <Box display="flex" justifyContent="space-between" mb="3">
            <Text paddingLeft="1px">Remove Line</Text>
            <span>
              <Kbd>Ctrl</Kbd> + <Kbd>D</Kbd>
            </span>
          </Box>
          <Box display="flex" justifyContent="space-between" mb="3">
            <Text paddingLeft="1px">Find Next</Text>
            <span>
              <Kbd>Ctrl</Kbd> + <Kbd>K</Kbd>
            </span>
          </Box>
          <Box display="flex" justifyContent="space-between" mb="3">
            <Text paddingLeft="1px">Find Previous</Text>
            <span>
              <Kbd>Ctrl</Kbd> +<Kbd>Shift</Kbd> + <Kbd>K</Kbd>
            </span>
          </Box>
          <Box display="flex" justifyContent="space-between" mb="3">
            <Text paddingLeft="1px">Move Line(s) Up/Down</Text>
            <span>
              <Kbd>Alt</Kbd> + <Kbd>↑</Kbd>/<Kbd>↓</Kbd>
            </span>
          </Box>
          <Box display="flex" justifyContent="space-between" mb="3">
            <Text paddingLeft="1px">Copy Line(s) Up/Down</Text>
            <span>
              <Kbd>Alt</Kbd> + <Kbd>Shift</Kbd> + <Kbd>↑</Kbd>/<Kbd>↓</Kbd>
            </span>
          </Box>

          <Divider mb="3" />
          <Box display="flex" justifyContent="space-between" mb="3">
            <Text paddingLeft="1px">Pdf Zoomin</Text>
            <span>
              <Kbd>Alt</Kbd> + <Kbd>+</Kbd>
            </span>
          </Box>

          <Box display="flex" justifyContent="space-between" mb="3">
            <Text paddingLeft="1px">Pdf Zoomout</Text>
            <span>
              <Kbd>Alt</Kbd> + <Kbd>-</Kbd>
            </span>
          </Box>
          <Divider mb="3" />

          {latexShortcuts.map(({ key, snippet }) => {
            const keys = key.split('-').map((k, idx, arr) => (
              <React.Fragment key={idx}>
                <Kbd>{k}</Kbd>
                {idx < arr.length - 1 ? ' + ' : ''}
              </React.Fragment>
            ));

            return (
              <Box display="flex" justifyContent="space-between" gap={"10px"} mb="3" key={key}>
                <Text paddingLeft="1px" style={{ maxWidth: "65%" }}>{snippet}</Text>
                <span>{keys}</span>
              </Box>
            );
          })}


          <Divider mb="3" />

          <Box display="flex" justifyContent="space-between" mb="3">
            <Text paddingLeft="1px">/textbf</Text>
            <span>
              <Kbd>Ctrl</Kbd> + <Kbd>B</Kbd>
            </span>
          </Box>
          <Box display="flex" justifyContent="space-between" mb="3">
            <Text paddingLeft="1px">/textit</Text>
            <span>
              <Kbd>Ctrl</Kbd> + <Kbd>I</Kbd>
            </span>
          </Box>
          <Box display="flex" justifyContent="space-between" mb="3">
            <Text paddingLeft="1px">/nobreak</Text>
            <span>
              <Kbd>Alt</Kbd> + <Kbd>B</Kbd>
            </span>
          </Box>
          {/*MARK:Custom 
          shortcuts */}
          {[1, 2, 3, 4, 5, 6].map((num) => (
            <Box display="flex" justifyContent="space-between" mb="3" key={num}>
              <Box display="flex" alignItems="center" width="auto">
                <Textarea
                  style={{
                    minHeight: "35px",
                    width: "200px",
                    padding: "4px",
                    fontSize: "14px"
                  }}
                  placeholder="Add a shortcut"
                  value={shortcuts[`shortcut${num}`] || ""}
                  onChange={(e) => inputChange(e, num)}
                />
              </Box>
              <span>
                <Kbd>Ctrl</Kbd> + <Kbd>{num}</Kbd>
              </span>
            </Box>
          ))}
          {/* <Button onClick={() => setChange(!change)}>Update</Button> */}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default Help;
